/**
 * Одно изменение поля сущности — зеркало ChangelogEntityDiff.php.
 *
 * Только данные. Типизация значений (BoolValue/IntValue/DateSimple на беке)
 * и текстовое представление («Установлено … с … на …») к фронту не относятся:
 * значения приезжают сырыми, а человекочитаемый текст собирает view-слой
 * (ChangelogFormatters + view-модель записи фида).
 */
class ChangelogEntityDiff {

	/** Имя изменённого поля сущности (ключ изменения на беке). */
	propertyName: string;

	/** Значение до изменения. null — поле было установлено впервые. */
	oldValue: any;

	/** Значение после изменения. null — поле очищено/удалено. */
	newValue: any;

	static fromServer(data: any): ChangelogEntityDiff {
		const diff = new ChangelogEntityDiff();

		diff.propertyName = data.propertyName;
		diff.oldValue     = data.oldValue ?? null;
		diff.newValue     = data.newValue ?? null;

		return diff;
	}
}

export default ChangelogEntityDiff;
